'use strict';

var d3 = require('d3');
var Zoom = function Zoom() {
  return function () {
    var scales;
    var params;
    var toRedraw;
    var defaultZoomScaleExtent = [1, 4];
    function parseZoomScaleExtent(zoomScaleExtent) {
      return zoomScaleExtent ? [zoomScaleExtent[0] || defaultZoomScaleExtent[0], zoomScaleExtent[1] || defaultZoomScaleExtent[1]].sort() : defaultZoomScaleExtent;
    }
    var zoom = function zoom(container) {
      function zoomed(container) {
        toRedraw.forEach(function (f) {
          bindPan(d3.event);
          container.call(f);
        });
      }
      function bindPan(e) {
        var tx = Math.min(0, Math.max(e.translate[0], params.width - params.width * e.scale));
        var ty = Math.min(0, Math.max(e.translate[1], params.height - params.height * e.scale));
        zoomer.translate([tx, ty]);
      }
      var zoomer = d3.behavior.zoom();
      zoomer.x(scales.xScale);
      zoomer.scaleExtent(parseZoomScaleExtent(params.zoomScaleExtent));
      zoomer.on('zoom', zoomed.bind(this, container));
      container.call(zoomer);
    };
    zoom.params = function (value) {
      params = value;
      return zoom;
    };
    zoom.scales = function (value) {
      scales = value;
      return zoom;
    };
    zoom.toRedraw = function (value) {
      toRedraw = value;
      return zoom;
    };
    return zoom;
  };
};
Zoom.$inject = [];
module.exports = Zoom;